import React, { useState, useEffect } from "react";
import TextInput from "../../component/textInput/TextInput";
import {
  LoginBackButton,
  PrimaryButton,
} from "../../component/buttonComponent/ButtonComponent";
import "./ForgotPassword.css";
import ImgWithTitle from "../../component/workspaceContainer/ImgWithTitle";
import { useNavigate } from "react-router-dom";
import FooterImage from "../../image/header.png";
import SnackBar from "../../component/Snackbar/Snackbar";
import Cookies from 'js-cookie'
import { APISendForgetPasswordEmail } from "../../config/utilities/APIs";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [email, setEmail] = useState("");
  const [keyUp, setKeyUp] = useState("", false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarType, setSnackbarType] = useState("");
  const [snackbarTitle, setSnackbarTitle] = useState("");
  const [snackbarSubtitle, setSnackbarSubtitle] = useState("");
  const navigate = useNavigate();

  const btnBack = (e) => {
    e.preventDefault();
    navigate("/login", { replace: true });
  };

  const isValidEmail = (email) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
  };

  const resetPassword = async () => {
    setLoading(true);

    try {
      const response = await APISendForgetPasswordEmail(email, setLoading);
        
      if (response.status === 200) {
        Cookies.set("resetEmail", email, { expires: 1, path: "/" });
        navigate("/emailcheck");
      } else {
        throw new Error(
          response.response?.data?.message ||
            "Failed to send reset password email"
        );
      }
    } catch (error) {
      setShowSnackbar(true);
      setSnackbarTitle("Send Reset Password Email Failed");
      setSnackbarSubtitle(error.message || "An error occurred");
      setSnackbarType("error");
    } finally {
      setLoading(false);
    }
  };

  const emailOnChangeFunction = (e) => {
    setEmail(e.target.value);
    if (emailError) {
      setEmailError(false);
    }
  };

  const isFormValid = () => {
    if (email.trim() === "") {
      setEmailError(false);
      return false;
    }

    const isValid = isValidEmail(email);
    setEmailError(!isValid);
    return isValid;
  };

  useEffect(() => {
    isFormValid();
  }, [email]);

  return (
    <>
      <div className="forgot-password-container-main">
        <div className="forgot-password-container">
          <div className="img-with-title-container">
            <ImgWithTitle
              titleText="Forgot password?"
              subText="No worries, it happens to the best of us. Enter your email below and we'll send you reset instructions."
              icon="Users"
            />
          </div>
          <div style={{ width: "100%" }}>
            <TextInput
              label=""
              placeholder="Enter email"
              setInput={setEmail}
              input={{ email }}
              name="email"
              type="text"
              error={emailError}
              setError={setEmailError}
              keyUp={keyUp}
              setKeyUp={setKeyUp}
              onChangeFunction={emailOnChangeFunction}
              errorMessage="Enter valid email"
            />
          </div>
          <div className="forgot-password-reset-button">
            <PrimaryButton
              label="Reset password"
              onClickFunction={resetPassword}
              loading={loading}
              disable={!isValidEmail(email)}
            />
            <LoginBackButton
              fontSize="0.875rem"
              label="Back to log in"
              btnClickBack={btnBack}
              backgroundColor="#FFFFFF"
            />
          </div>
        </div>
        <div className="login-logo-footer">
          <div className="login-logo">
            <img
              loading="lazy"
              src={FooterImage}
              className="logo"
              alt="header-logo"
            />
          </div>
        </div>
      </div>
      {showSnackbar && (
        <div className="notification">
          <SnackBar
            state={showSnackbar}
            setState={setShowSnackbar}
            title={snackbarTitle}
            subtitle={snackbarSubtitle}
            module={snackbarType}
            action={snackbarType}
          />
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
